<form class="space-y-5" [formGroup]="form" (ngSubmit)="submit()">
  <div class="space-y-2">
    <div class="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Type</div>
    <app-segmented-toggle
      [options]="typeOptions"
      [value]="`${form.controls.type.value}`"
      size="sm"
      [fill]="true"
      ariaLabel="Help feedback type"
      (valueChange)="setType($event)">
    </app-segmented-toggle>
    @if (form.controls.type.touched && form.controls.type.invalid) {
      <p class="text-xs text-rose-300">Type is required.</p>
    }
  </div>

  <div class="space-y-2">
    <label class="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500" for="feedback-title">
      Title
    </label>
    <input
      id="feedback-title"
      class="w-full rounded-xl border border-slate-800 bg-slate-950 px-3 py-2 text-sm text-slate-100 outline-none transition placeholder:text-slate-600 focus:border-sky-500/60"
      formControlName="title"
      placeholder="Short summary of the issue"
    />
    @if (form.controls.title.touched && form.controls.title.invalid) {
      <p class="text-xs text-rose-300">Title is required.</p>
    }
  </div>

  <div class="space-y-2">
    <div class="flex items-center justify-between">
      <label class="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
        Description
      </label>
    </div>

    <app-rich-description-editor
      formControlName="description"
      [attachments]="[]"
      [localFileMap]="localFileMap"
      [apiEndpoint]="angularEndpoint"
      (fileDrop)="onFileDropFromEditor($event)"
      (deleteAttachment)="removeFileByAttachmentId($event)">
    </app-rich-description-editor>

    @if (form.controls.description.touched && form.controls.description.invalid) {
      <p class="text-xs text-rose-300">Description is required.</p>
    }
  </div>

  <div class="space-y-3">
    <div class="flex items-center justify-between">
      <span class="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 flex items-center gap-1.5">
        <app-icon icon="mdi-paperclip" class="text-slate-400"></app-icon>
        Attachments ({{ selectedFiles().length }})
      </span>

      <label class="cursor-pointer">
        <input
          type="file"
          multiple
          (change)="onFilesSelected($event)"
          class="hidden"
          [disabled]="loading" />
        <span class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-xl bg-sky-500/10 text-sky-400 hover:bg-sky-500/20 transition-colors border border-sky-500/20">
          <app-icon icon="mdi-upload" class="text-sm"></app-icon>
          <span>Attach Files</span>
        </span>
      </label>
    </div>

    <div class="border border-dashed border-slate-800 hover:border-sky-500/40 bg-slate-950/60 hover:bg-slate-900/50 rounded-2xl p-4 text-center transition-all">
      <app-icon icon="mdi-cloud-upload-outline" class="text-2xl text-slate-500 mb-1"></app-icon>
      <p class="text-xs text-slate-400">Drag & drop screenshots or files here (Max 25MB per file)</p>
    </div>

    @if (selectedFiles().length) {
      <div class="divide-y divide-slate-800/80 rounded-2xl border border-slate-800 bg-slate-950/80 overflow-hidden">
        @for (file of selectedFiles(); track $index) {
          <div class="flex items-center justify-between p-3 hover:bg-slate-900/60 transition-colors text-xs">
            <div class="flex items-center gap-3 min-w-0 pr-2">
              <div class="p-2 rounded-xl bg-slate-900 text-sky-400 shrink-0">
                <app-icon [icon]="getAttachmentIcon(file.type)"></app-icon>
              </div>
              <div class="min-w-0">
                <p class="font-medium text-slate-200 truncate">{{ file.name }}</p>
                <p class="text-[11px] text-slate-500">{{ formatFileSize(file.size) }}</p>
              </div>
            </div>

            <div class="flex items-center gap-1 shrink-0">
              <button
                type="button"
                (click)="insertReferenceInDescription(file, $index)"
                class="inline-flex items-center gap-1 px-2.5 py-1 text-[11px] font-medium text-sky-400 hover:text-sky-300 bg-sky-500/10 hover:bg-sky-500/20 rounded-lg transition-colors border border-sky-500/20"
                title="Insert attachment reference in description text">
                <app-icon icon="mdi-plus" class="text-xs"></app-icon>
                <span>Insert in text</span>
              </button>
              <button
                type="button"
                (click)="removeFile($index)"
                class="p-2 rounded-lg text-slate-400 hover:text-rose-400 hover:bg-slate-900 transition-colors"
                [disabled]="loading"
                title="Remove file">
                <app-icon icon="mdi-close"></app-icon>
              </button>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="flex items-center justify-end">
    <app-button type="submit" [loading$]="loading">
      Send feedback
    </app-button>
  </div>
</form>
